import {
  Component,
  OnInit
} from '@angular/core';
import { ChangeStatusModalDirective } from '../change-status-modal.directive';
import { AuctionService, LaunchDarklyService } from 'remarketing-angular-library';
import { Store } from '@ngxs/store';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';


@Component({
    selector: 'app-mark-arrived-modal',
    templateUrl: './mark-arrived-modal.component.html',
    styleUrls: ['./mark-arrived-modal.component.scss'],
    imports: [TranslocoDirective]
})
export class MarkArrivedModalComponent extends ChangeStatusModalDirective implements OnInit {
  textArrivedVehicles: string;
  textArrivedVehicle: string;

  constructor(store: Store, auctionService: AuctionService, launchDarklyService: LaunchDarklyService, readonly translocoService: TranslocoService) {
    super(store, auctionService, launchDarklyService, translocoService);
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  get headline() {
    if (this.selectedVehicles.length > 1) {
      return this.textArrivedVehicles;
    } else {
      return this.textArrivedVehicle;
    }
  }

  getTranslations() {
    super.getTranslations();
    this.translocoService
      .selectTranslateObject('sellModule.manageInventory.actionListModal.markArrivedModal')
      .subscribe(translate => {
        this.textArrivedVehicles = translate.textArrivedVehicles;
        this.textArrivedVehicle = translate.textArrivedVehicle;
      });
  }
}
